"use client"

import { Box, Flex, Image, Link, Heading, For} from "@chakra-ui/react";
import Container from '@/components/partials/Container';
import { socialList } from '@/helpers/constants';
import LogoSvg from '@/lib/logo';
import Advertising from '@/components/Advertising';
import { LuIcon } from "@/components/partials/Helpers";
import { LuX } from "react-icons/lu"
import { useEffect, useState } from 'react';
import { setCookie, getCookie } from 'cookies-next';

export default function Footer({ ads, categories, pages }) {

  const catColumn = Math.round(categories.length / 3);
  const catListA = categories.slice(0, catColumn);
  const catListB = categories.slice(catColumn, catColumn * 2);
  const catListC = categories.slice(catColumn * 2, categories.length);

  const socials = socialList();

  const [showFixedAds, setShowFixedAds] = useState(false);

  useEffect(() => {
    const cdcFooterPub = getCookie('cdc_footer_pub', null);

    if (!cdcFooterPub) {
      setShowFixedAds(true);
    }
  }, []);

  const handleClose = () => {
    const days = 1;
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (days * 24 * 60 * 60 * 1000));

    setCookie('cdc_footer_pub', '1', {
      expires: expirationDate,
      path: '/',
    });

    setShowFixedAds(false);
  };

  return (
    <>
      <Box w="100%" bgColor="gray.500" color="white" py="20" borderTopWidth="6px" borderColor="orange.500">
        <Container>
          <Flex
            flexDirection={{ base: 'column', lg: 'row' }}
            justifyContent={{ base: 'center', lg: 'space-between' }}
            alignItems={{ base: 'center', lg: 'start' }}
            textAlign={{ base: 'center', lg: 'left' }}
            >
            <Box mb={{ base: '8', lg: '0' }} w="100%" maxW={{ base: '300px', lg: '220px' }}>
              <Box w="100%">
                <LogoSvg />
              </Box>
            </Box>

            <Box mb={{ base: '8', lg: '0' }}>
              <Heading as="h1" fontFamily="inherit" mb="4" color="yellow.500" borderBottomWidth="1px" borderColor="orange.500">Institucional</Heading>

              <Flex>
                <Flex as="ul" flexDirection="column" listStylePosition="inside" minW="200px">
                  <For each={pages}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/pagina/${item.pageSlug}`} title={item.pageTitle} color="white" _hover={{ color: 'orange.500'}} >
                          { item.pageTitle }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>
              </Flex>
            </Box>

            <Box mb={{ base: '8', lg: '0' }} px="6">
              <Heading as="h1" fontFamily="inherit" mb="4" color="yellow.500" borderBottomWidth="1px" borderColor="orange.500">Categorias</Heading>

              <Flex>
                <Flex as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={catListA}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/categoria/${item.taxSlug}`} title={item.taxName} color="white" _hover={{ color: 'orange.500'}} >
                          { item.taxName }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>

                <Flex ml={{ base: '10', md: '24' }} as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={catListB}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/categoria/${item.taxSlug}`} title={item.taxName} color="white" _hover={{ color: 'orange.500'}} >
                          { item.taxName }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>

                <Flex ml={{ base: '10', md: '24' }} as="ul" flexDirection="column" listStylePosition="inside">
                  <For each={catListC}>
                    {(item, key) => (
                      <Box key={key} as="li" >
                        <Link href={`/categoria/${item.taxSlug}`} title={item.taxName} color="white" _hover={{ color: 'orange.500'}} >
                          { item.taxName }
                        </Link>
                      </Box>
                    )}
                  </For>
                </Flex>
              </Flex>
            </Box>

            <Box>
              <Box py={{ base: '8', lg: '0' }}>
                <Heading as="h1" fontFamily="inherit" mb="4" color="yellow.500" borderBottomWidth="1px" borderColor="orange.500">Redes Sociais</Heading>

                <Flex justifyContent={{ base: 'center', lg: 'start' }}>
                  <For each={socials}>
                    {(item, key) => (
                      <Box as={Link} key={key} mr="2" target="_blank" href={item.url} title={item.label} color="white" _hover={{ color: 'orange.500'}}>
                          <LuIcon icon={item.icon} size="30px" />
                      </Box>
                    )}
                  </For>
                </Flex>
              </Box>

              <Box mt="6">
                <Link target="_blank" href="https://cloudflash.com.br">
                  <Image
                    src="https://r2.flize.cloud/cloudflash/stamp_white.png"
                    alt="Hospedado por CloudFlash"
                  />
                </Link>
              </Box>
            </Box>
          </Flex>
        </Container>
      </Box>

      {ads && ads.length > 0 && (
        <Box
          position="fixed"
          bottom="0"
          left="0"
          w="100%"
          bgColor="rgba(255, 255, 255, 0.8)"
          display={ showFixedAds === true ? 'block' : 'none' }
        >
          <Box position="relative">
            <Box position="absolute" top="-7" right="10" cursor="pointer" onClick={(e) => handleClose()}>
              <LuX size="32px" />
            </Box>

            <Container>
              <Advertising ads={ads} />
            </Container>
          </Box>
        </Box>
      )}

      <Box w="100%" textTransform="uppercase" textAlign="center" fontSize="10px" borderTopWidth="1px" borderColor="orange.600" bgColor="gray.500" color="white" p="4">
        Desenvolvido por <Link target="_blank" href="https://flize.com.br" color="inherit">Flize Tecnologia</Link>
      </Box>
    </>
  )
}
